module.exports = __webpack_public_path__ + "static/new-logo-2024-e2a57726f7db34b3c89ea1c53ec67c6d.png";